module.exports = {
  DK: require('./locales/dk'),
  US: require('./locales/us'),
  international: require('./locales/international')
};
